exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#layersJoinOptionsModal .v--modal-box.v--modal{min-height:250px!important;min-width:400px!important}#layersJoinOptionsModal *{font-size:12px}#layersJoinOptionsModal .checkbox--big i{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fbc2c9a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/edition/modals/LayersJoinOptions.vue
// module id = 2189
// module chunks = 0